export const thumbnail: string = 'thumbnail';
export const threeImageButton: string = 'threeImageWithButton';
